import React from "react";
import './Footer.css';
import SponsorBar from './Sponsors.js'
import Links from './Links.js'

export default class Footer extends React.Component {

    year = new Date().getFullYear();

    render() {
        return <footer class="footer">
            <hr />
            {/* <p>Thank you to our Platinum and Gold tier sponsors!</p> */}
            {/* <SponsorBar /> */}
            <div class="foot">
                <p id="findUs">Find us!</p>
                <Links />
                <p class="copyright">
                    &copy; 2013 - {this.year} Engineers Without Borders USA-WPI<br />
                    100 Institute Road, Worcester, MA 01609
                </p>
            </div>
        </footer>;
    }
}